export function byteFormat(bytes, decimals) {
	if (typeof bytes != "number") return "-";
	if (!bytes) return "0 Bytes";
	var k = 1024,
		dm = decimals <= 0 ? 0 : decimals || 2,
		sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
		i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
